import React from "react";
import { Link } from "react-router-dom";
import { fileUrl } from "@/lib/api";

const pct = (price, mrp) => Math.round(((mrp - price) / mrp) * 100);

export const ProductCard = ({ product, index = 0 }) => {
  const img = product.images?.[0];
  const hasDiscount =
    product.compare_at_price && product.compare_at_price > product.price;
  return (
    <Link
      to={`/product/${product.id}`}
      className={`group block rise rise-${(index % 4) + 1}`}
      data-testid={`product-card-${product.id}`}
    >
      <div className="hover-zoom aspect-[4/5] bg-[#f3efea] overflow-hidden mb-4 relative">
        {img ? (
          <img
            src={fileUrl(img)}
            alt={product.name}
            className="w-full h-full object-cover"
            loading="lazy"
          />
        ) : (
          <div className="w-full h-full flex items-center justify-center text-[#c58b76] font-serif text-3xl">
            ✦
          </div>
        )}
        {product.featured && !hasDiscount && (
          <div className="absolute top-4 left-4 overline bg-white/80 backdrop-blur px-2 py-1">
            New
          </div>
        )}
        {hasDiscount && (
          <div
            className="absolute top-4 left-4 bg-[#8b3a36] text-white text-[10px] uppercase tracking-[0.16em] px-2 py-1 font-semibold"
            data-testid={`discount-badge-${product.id}`}
          >
            −{pct(product.price, product.compare_at_price)}% off
          </div>
        )}
      </div>
      <div className="flex items-start justify-between gap-3">
        <div>
          <h3 className="font-serif text-xl text-[#1a1918] leading-tight">{product.name}</h3>
          <p className="text-xs text-[#5c5a56] mt-1 tracking-wide">{product.material}</p>
        </div>
        <div className="text-right whitespace-nowrap">
          <div className="font-serif text-lg text-[#1a1918]">
            ₹{product.price?.toLocaleString("en-IN")}
          </div>
          {hasDiscount && (
            <div className="text-xs text-[#5c5a56] line-through mt-0.5">
              ₹{product.compare_at_price.toLocaleString("en-IN")}
            </div>
          )}
        </div>
      </div>
    </Link>
  );
};
